module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA GAZOWA.c9acc23f.svg";